__webpack_require__.p = "/colors-remapping/onboarding/";